import styled from 'styled-components';

export const CarList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(19.375rem, 1fr));
  margin-bottom: 4rem;

  grid-gap: 0.625rem;

  width: 100%;

  @media (max-width: 882px) {
    grid-template-columns: repeat(auto-fill, 100%);
  }
`;
